const modalReason = {
  actionCancel: 'Cancel',
  adminLocked: 'Admin Locked',
  constractTerminated: 'Constract Terminated',
  temporarySuspended: 'Temporary Suspended',
  textAreaPlaceholder: 'Enter reason',
};

export default modalReason;
